import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';
import Global from '../../../../store/global-selectors';
import { LabelBatchErrorWarn } from './index';

export const LabelBatchErrorWarnContainer = (props) => {
  const { jobGuid } = props;
  const job = useSelector((state) => Global.selectBulkJobByJobGuid(state, { jobGuid }));

  return <LabelBatchErrorWarn job={job} {...props} />;
};

LabelBatchErrorWarnContainer.propTypes = {
  jobGuid: PropTypes.string.isRequired,

  modalFrameworkMethods: ModalFrameworkMethodsPropType,
};
